import useDefinedContext from "hooks/useDefinedContext";
import { LocaleContext } from "../LocaleProvider";

interface UseLocaleProps {}

function useLocale(props?: UseLocaleProps) {
  return useDefinedContext(LocaleContext);
}

export default useLocale;
